import { INeoAction } from './../Actions.interface';
import { STATUS, REQUEST_ACTIONS, STATIC_ACTIONS } from '../../Constants/Actions.constants';
import { DownloadJob } from '../../Models/DTO/DownloadJob.model';

interface DownloadJobState {
  jobs: DownloadJob[];
  requestedJobs: string[];
}

const INITIAL_STATE: DownloadJobState = {
  jobs: [],
  requestedJobs: [],
};

const addUniqueJobs = (currentList: DownloadJob[], newList: DownloadJob[]) => {
  const trimmedDownOldList = currentList.filter(
    (job) => job && newList.findIndex((newJob) => newJob.id === job.id) === -1,
  );
  return newList.concat(trimmedDownOldList);
};

const addUniqueIds = (currentList: string[], newList: string[]) => {
  const trimmedDownOldList = currentList.filter((id) => id && !newList.includes(id));
  return newList.concat(trimmedDownOldList);
};

const removeBrokenIds = (currentList: string[], newList: string[]) =>
  currentList.filter((id) => newList.includes(id));

export default (state = INITIAL_STATE, action: INeoAction): DownloadJobState => {
  const { name, payload, status } = action;

  if (name === REQUEST_ACTIONS.EXPORT_CUSTOMERS) {
    // Adding a download job
    if (status === STATUS.SUCCESS) {
      const payloadAsArray = Array.isArray(payload) ? payload : [payload];
      return {
        jobs: addUniqueJobs(state.jobs, payloadAsArray),
        requestedJobs: addUniqueIds(
          state.requestedJobs,
          payloadAsArray.map((job: DownloadJob) => job.id),
        ),
      };
    }
  }

  if (name === REQUEST_ACTIONS.JOB_STATUS) {
    // Adding a download job
    if (status === STATUS.SUCCESS) {
      return {
        ...state,
        jobs: addUniqueJobs(state.jobs, payload),
        requestedJobs: removeBrokenIds(
          state.requestedJobs,
          payload.map((job: DownloadJob) => job.id),
        ),
      };
    }
  }

  if (name === STATIC_ACTIONS.REMOVE_JOB_FROM_REQUEST_LIST) {
    return {
      ...state,
      requestedJobs: [...state.requestedJobs.filter((jobId) => jobId !== payload)],
    };
  }

  return state;
};
